import JoditEditor from "jodit-react";
import React from "react";

import deleteIcon from "../../../src/assets/images/delete-icon.png";
import addIcon from "../../assets/images/add-icon.svg";
import InputTextField from "./inputTextField";
// import InputTextField from "./Antd/InputTextField";

const MultipleAddFAQs = ({ register, errors, setValue, faqs, setFaqs }) => {
  const addFaqs = () => {
    setFaqs([
      ...faqs,
      {
        id: (faqs?.[faqs.length - 1]?.id || 0) + 1,
        question: "",
        answer: "",
      },
    ]);
  };

  const removeFaq = (id) => {
    setValue(`answer-${id}`, null);
    setValue(`question-${id}`, "");
    const updatedList = faqs.filter((item) => item.id !== id);
    setFaqs(updatedList);
  };

  return (
    <div className="mb-32">
      {faqs.length > 0 && (
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            rowGap: "5px",
          }}
        >
          {faqs.map((item, idx) => (
            <div
              key={`faq-${item.id}`}
              style={{ gap: "12px" }}
              className="align-items-center medicineFaqs"
            >
              <div className="d-flex align-items-end justify-content-between mt-4">
                <div className="pe-3 faqMedicineInputWrapper">
                  <InputTextField
                    id={`question-${item.id}`}
                    register={register}
                    labelName={`Question ${idx + 1}`}
                    errorText="Please enter the Question"
                    errors={errors}
                    name={`question-${item.id}`}
                    placeholder="Type here..."
                    className="w-100 customFields "
                  />
                </div>
                <div
                  className="faqDeleteImgWrapper"
                  onClick={() => removeFaq(item.id)}
                >
                  <img
                    src={deleteIcon}
                    className="faqDeleteImg"
                    alt="Delete FAQ"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
              <div>
                <label className="mt-3 mb-2 fs14fw600">
                  Answer <span className="star">*</span>
                </label>
                <JoditEditor
                  value={item.answer}
                  onChange={(value) => {
                    const updatedFaqs = faqs.map((faq) =>
                      faq.id === item.id ? { ...faq, answer: value } : faq,
                    );
                    setFaqs(updatedFaqs);
                    setValue(`answer-${item.id}`, value);
                  }}
                  className="w-100"
                />
              </div>
            </div>
          ))}
        </div>
      )}
      <div
        className="medicineAddFAQ medicineFaqclr d-flex gap-2 mt-5"
        onClick={addFaqs}
      >
        <button className="fs16fwb medicineFaqclr text-white border-0">
          <img src={addIcon} className="me-2" alt="Add FAQ" />
          Add FAQ
        </button>
      </div>
    </div>
  );
};

export default MultipleAddFAQs;
